export const expandableMenuMetaData = {
    isRepeatable: false
}
